module.exports = __webpack_public_path__ + "static/media/chevron_down_error.6664c0eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/chevron_down_error.svg
// module id = 2201
// module chunks = 0